/* eslint-disable import/no-cycle */
import api from './api.service';

function index(schoolId, params) {
  return api.get(`/schools/${schoolId}/codes`, params);
}

function get(schoolId, codeId, params) {
  return api.get(`/schools/${schoolId}/codes/${codeId}`, params);
}

function create(schoolId, params) {
  return api.post(`/schools/${schoolId}/codes`, params);
}

function update(schoolId, codeId, params) {
  return api.put(`/schools/${schoolId}/codes/${codeId}/update`, params);
}

function remove(schoolId, codeId, params) {
  return api.delete(`/schools/${schoolId}/codes/${codeId}`, params);
}

function save(params) {
  return (params.id)
  ? update(params.school_id, params.id, params)
  : create(params.school_id, params);
}

export const schoolsCodesService = {
  index,
  get,
  create,
  update,
  remove,
  save,
};
